import { Pipe, PipeTransform } from '@angular/core';
import { Match } from '../interfaces/interfaces';

@Pipe({
  name: 'sortDate'
})
export class SortDatePipe implements PipeTransform {

    transform(value: Match[]): Match[] {

        return value.sort((a: Match, b: Match) => new Date(a.start).getTime() - new Date(b.start).getTime());
  }

}
